import { Box } from '@mui/material'
import React, { useState } from 'react'
const counters = [
  { name: 'Adults', defaultValue: 1 },
  { name: 'Children', defaultValue: 0 },
  { name: 'Infants', defaultValue: 0 }
]

const Counter = ({ name, defaultValue, onCounterChange, setBookGuest }) => {
  const [count, setCount] = useState(defaultValue)
  const incrementCount = () => {
    setCount(defaultValue + 1)
    onCounterChange(name, defaultValue + 1)
  }
  const decrementCount = () => {
    if (count > 0) {
      if (name === 'Adults') {
        if (defaultValue > 1) {
          setCount(defaultValue - 1)
          onCounterChange(name, defaultValue - 1)
        }
      } else {
        setCount(defaultValue - 1)
        onCounterChange(name, defaultValue - 1)
      }
    }
  }

  return (
    <>
      <div className='row y-gap-10 justify-between items-center'>
        <div className='col-auto'>
          <div className='text-15 lh-12 fw-500'>{name}</div>
          {name === 'Children' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>2-12 years at</div>
          )}
          {name === 'Children' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>
              time of travel
            </div>
          )}
          {name === 'Adults' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>12+ years at</div>
          )}
          {name === 'Adults' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>
              time of travel
            </div>
          )}
          {name === 'Infants' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>Under 2 years</div>
          )}
          {name === 'Infants' && (
            <div className='text-14 lh-12 text-light-1 mt-5'>
              time of travel
            </div>
          )}
        </div>
        {/* End .col-auto */}
        <div className='col-auto'>
          <div className='d-flex items-center js-counter'>
            <button
              className='button -outline-dark-3 text-dark-3 size-38 rounded-4 js-down'
              onClick={decrementCount}
            >
              <i className='icon-minus text-12' />
            </button>
            {/* decrement button */}
            <div className='flex-center size-20 ml-15 mr-15'>
              <div className='text-15 js-count'>{defaultValue}</div>
            </div>
            {/* counter text  */}
            <button
              className='button -outline-dark-3 text-dark-3 size-38 rounded-4 js-up'
              onClick={incrementCount}
            >
              <i className='icon-plus text-12' />
            </button>
            {/* increment button */}
          </div>
        </div>
        {/* End .col-auto */}
      </div>
      {/* End .row */}
      <div className='border-top-light mt-24 mb-24' />
    </>
  )
}

const GuestSearch = ({ setGuestCounts, guestCounts }) => {
  const handleCounterChange = (name, value) => {
    setGuestCounts(prevState => ({ ...prevState, [name]: value }))
  }
  return (
    <div className='searchMenu-guests lg:py-20  sm:px-20 js-form-dd position-relative m-auto'>
      <div
        data-bs-toggle='dropdown'
        data-bs-auto-close='outside'
        aria-expanded='false'
        data-bs-offset='0,22'
      >
        
          <div className='text-15 text-light-1 ls-2 lh-16'>
            <div className='d-flex items-center'>
              <h6>{guestCounts.Adults} Adults</h6>
              <img
                src='/img/filtericons/arrow.svg'
                alt='quote'
                width='20'
                className='mr-10'
              />
            </div>
          </div>
        
        {/* <div className="text-15 text-light-1 ls-2 lh-16">
        <span className="js-count-adult">{guestCounts.Adults}</span> adults -{" "}
        <span className="js-count-child">{guestCounts.Children}</span>{" "}
        childeren - <span className="js-count-room">{guestCounts.Rooms}</span>{" "}
        room
      </div> */}
      </div>
      {/* End guest */}

      <div className='shadow-2 dropdown-menu min-width-400'>
        <Box
          className='bg-white px-30 py-30 rounded-4 counter-box'
          sx={{
            width: { xs: '320px', md: 'auto' }
          }}
        >
          {counters.map(counter => (
            <Counter
              key={counter.name}
              name={counter.name}
              defaultValue={guestCounts[counter.name]}
              onCounterChange={handleCounterChange}
            />
          ))}
        </Box>
      </div>
    </div>
  )
}
export default GuestSearch
